<template>
  <VaNavbar class="app-layout-navbar py-2 px-0" color="sidebar-background">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="sidebar-text"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page">
          <AppWordmark :height="20" start="sidebar-active-text" />
        </RouterLink>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import AppWordmark from '../AppWordmark.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;
  // A dark gradient distinct from the sidebar's flat neutral-carbon fill (var(--va-sidebar-
  // background)) — coordinated (same dark family) but deliberately not identical, so the navbar
  // reads as its own surface instead of visually fusing into one block with the sidebar below it.
  // The end stop carries a faint warm (brownish) undertone — a subtle nod to the orange primary
  // — replacing what used to be a violet undertone matched to the old indigo primary.
  // Expressed as `background-image` (not `background`/`background-color`) so it paints over — and
  // isn't fought by — the inline `background-color` VaNavbar itself sets from its `color` prop.
  background-image: linear-gradient(135deg, #17171b 0%, #241e1a 100%);
  // Same hairline token as the sidebar's own item borders (vuestic.scss) — a soft, low-contrast
  // seam either way: barely visible against the dark sidebar, a gentle edge against the light
  // main content, without ever reading as a hard contrasting line.
  border-bottom: 1px solid var(--va-sidebar-border);

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
